const SaveWaitingListEmail_mutate = `
    mutation saveWaitingListEmail(
      $email: String!) {
      saveWaitingListEmail(
        email: $email) {
		email
      }
    }
`;

const WaitingList_query = `
    query
    {
      waitingList
      {
          waitingListId
          email
          submitDate
      }
    }
`;

const DeleteWaitingListEmail_mutate = `
    mutation deleteWaitingListEmail($id: Int!) {
      deleteWaitingListEmail(id: $id) {
        response
      }
    }
`;


module.exports = {
  SAVE_WAITIG_LIST_EMAIL_MUTATION: SaveWaitingListEmail_mutate,
  WAITING_LIST_QUERY: WaitingList_query,
  DELETE_WAITIG_LIST_EMAIL_MUTATION: DeleteWaitingListEmail_mutate,
};
